export default __webpack_public_path__ + "static/CloudPouchLogoNegative-1207b6ae2b4eecaf192fab15b68675a4.png";